import { FormControlDirective } from '@angular/forms';
import { InputDirective } from './../../directives/input.directive';
import { Component, OnInit, ContentChild, Input } from '@angular/core';

@Component({
  selector: 'iq-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.scss'],
  host: {
    class: 'iq-radio-input'
  }
})
export class RadioInputComponent implements OnInit {
  @ContentChild(InputDirective) _control: InputDirective;

  @ContentChild(FormControlDirective)
  _formControl: FormControlDirective;

  @Input() label = '';

  constructor() {}

  ngOnInit() {}
}
